import { ASSIST_API } from 'services/assist-api/axios';
import { AssistQueryClient } from 'services/assist-api/query-client';
import type { LoginResult } from './login';

export const postChangeCustomer = async (customerId: number): Promise<LoginResult> => {
  const tokenData = await ASSIST_API.post<LoginResult>(`customers/${customerId}/set-active`);
  AssistQueryClient.invalidateQueries();
  return tokenData.data;
};
